import { UserContext } from '@/contexts/UserContextProvider';
import React, { useContext } from 'react';

const useFilter = () => {

  const {userFilter, setUserFilter} = useContext(UserContext);

  return [userFilter, setUserFilter];
};

export default useFilter
